import { createContext, useState, useEffect, useRef } from 'react';
import _ from 'lodash';

import useAuth from 'src/hooks/useAuth';
import usePrevious from 'src/hooks/usePrevious';

export const IntegrationsContext = createContext({});

export const IntegrationsContextProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const prevIsAuthenticated = usePrevious(isAuthenticated);

  const [msTeamsCaptionsUrl, setMsTeamsCaptionsUrl] = useState();
  const [zoomCaptionsUrl, setZoomCaptionsUrl] = useState();
  const zoomMsgOrderRef = useRef(0);

  useEffect(() => {
    const isLoggedOut = !isAuthenticated && prevIsAuthenticated;
    if (isLoggedOut) {
      clear();
    }
  }, [isAuthenticated, prevIsAuthenticated]);

  useEffect(() => {
    zoomMsgOrderRef.current = 0;
  }, [zoomCaptionsUrl]);

  const runIntegrations = (text) => {
    if (zoomCaptionsUrl) {
      zoomMsgOrderRef.current++;
    }
  };

  const clear = () => {
    setMsTeamsCaptionsUrl(null);
    setZoomCaptionsUrl(null);
  };

  const hasActiveIntegration = () => {
    return !_.isEmpty(msTeamsCaptionsUrl) || !_.isEmpty(zoomCaptionsUrl);
  };

  return (
    <IntegrationsContext.Provider
      value={{
        runIntegrations,
        clear,
        msTeamsCaptionsUrl,
        setMsTeamsCaptionsUrl,
        zoomCaptionsUrl,
        setZoomCaptionsUrl,
        hasActiveIntegration,
      }}
    >
      {children}
    </IntegrationsContext.Provider>
  );
};
